


























import { Vue, Component, Prop } from 'vue-property-decorator'
import PdfViewer from 'components/PdfViewer.vue'

@Component({
  components: {
    PdfViewer
  }
})
export default class ItemTopicViewerImage extends Vue {

  @Prop()
  readonly slide!: Json

  get extension () {
    const path = (this.slide.src || '').split('?')[ 0 ]
    const match = path.match(/\.(?<ext>[a-z]+)$/i)
    return match?.groups?.ext?.toLowerCase()
  }

  get image () {
    return ['png', 'jpg', 'jpeg', 'gif', 'bmp'].includes(this.extension)
  }

  get pdf () {
    return 'pdf' === this.extension
  }

  get text () {
    return 'txt' === this.extension
  }

  get office () {
    if (['docx', 'pptx', 'xlsx', 'doc', 'ppt', 'xls'].includes(this.extension)) {
      if (this.slide.src.startsWith('/')) {
        // return 'https://docs.google.com/gview?url=https://quizenter.com' + this.slide.src + '&embedded=true'
        return 'https://view.officeapps.live.com/op/embed.aspx?src=https://quizenter.com' + this.slide.src
      } else {
        try {
          const url = new URL(this.slide.src)
          // return 'https://docs.google.com/gview?url=' + this.slide.src + '&embedded=true'
          return 'https://view.officeapps.live.com/op/embed.aspx?src=' + this.slide.src
        } catch (e) {}
      }
    }
  }

  get movie () {
    try {
      const url = new URL(this.slide.src)
      if (url.hostname.includes('youtu.be')){
        const parts = url.pathname.substr(1).split('/')
        return 'https://www.youtube.com/embed/'+parts.shift()
      } else if (url.hostname.includes('youtube')) {
        return 'https://www.youtube.com/embed/'+url.searchParams.get('v')
      } else if (url.hostname.includes('vimeo')) {
        const parts = url.pathname.substr(1).split('/')
        return 'https://player.vimeo.com/video/' + parts.shift()
      }
    } catch (e) {}
  }

  get www () {
    try {
      const url = new URL(this.slide.src)
      return this.slide.src
    } catch (e) {}
  }
}
